export default __webpack_public_path__ + "static/media/t_wdt_c_1_2.53647b23.mp3";